import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1580371116562523';
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Safer injection logic
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Track PageView
    // @ts-ignore
    window.fbq('init', PIXEL_ID);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-45">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-46" />
    </noscript>;
}